/**
 * API Endpoints
 * Centralized API endpoint definitions
 */

export const API_ENDPOINTS = {
  // Newsletter
  newsletter: {
    subscribe: '/marketing/newsletter/subscribe',
  },

  // Early Access
  earlyAccess: {
    register: '/marketing/demo-waitlist/subscribe',
  },

  // Add more endpoints as needed
  // users: {
  //   profile: '/users/profile',
  //   update: '/users/update',
  // },
};

export default API_ENDPOINTS;
